import { render } from "./Footer2.vue?vue&type=template&id=ebd6d8dc"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"

import "./Footer2.vue?vue&type=style&index=0&id=ebd6d8dc&lang=scss"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__